import { DOCUMENT } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService
  ) {
    localStorage.setItem("check_update", "false");
    this.languageSetup();
  }

  languageSetup() {
    let language = localStorage.getItem("language");
    if (language === "1") {
      this.translate.use("ar");
      this.document.documentElement.dir = "rtl";
    } else {
      this.translate.use("en");
      this.document.documentElement.dir = "ltr";
    }
  }
}
